/**
 * Куда ведут вкладка «Задачник» и логотип.
 *
 * Прежде они всегда вели на /tasks, а оттуда — перенаправлением обратно
 * на доску. Нажатие на уже открытой доске размонтировало её целиком:
 * сбрасывались прокрутка столбцов, открытые окна и фильтры в адресе,
 * а подписка на события доски снималась и ставилась заново.
 *
 * Из других разделов путь по-прежнему /tasks: там проверяется, что
 * доступ к последней доске не утрачен.
 */

const BOARD_PATH = /^\/boards\/([^/]+)(\/.*)?$/;

export interface TaskbookLink {
  to: string;
  /** Уже на доске — переход не нужен. */
  stay: boolean;
}

export function taskbookLink(pathname: string, search: string): TaskbookLink {
  const match = BOARD_PATH.exec(pathname);
  const boardId = match?.[1];
  // «archived» — список архивных досок, а не доска.
  if (boardId === undefined || boardId === "archived") return { to: "/tasks", stay: false };

  const rest = match?.[2] ?? "";
  if (rest === "" || rest === "/") return { to: `${pathname}${search}`, stay: true };
  // Из карточки задачи — на ту же доску с теми же фильтрами (§25.5):
  // доска под карточкой смонтирована и не перерисовывается заново.
  if (rest.startsWith("/tasks/")) return { to: `/boards/${boardId}${search}`, stay: false };
  // Архив и настройки доски — на саму доску; их параметры фильтрами доски не являются.
  return { to: `/boards/${boardId}`, stay: false };
}
